import common from './common'

//入力保持
function inputRetention(obj) {
  let addressFormSelected = common.getStore(obj, 'addressFormSelected')
  if (addressFormSelected) {
    let pickupZipcode = addressFormSelected.YUBIN.split('-')
    obj.postcode.firstPickupZipcode.value = pickupZipcode[0]
    obj.postcode.lastPickupZipcode.value = pickupZipcode[1]
  }

  obj.selected = addressFormSelected
  obj.addressList = common.getStore(obj, 'addressList')
  obj.addresses.address = common.getStore(obj, 'address')
  obj.addresses.buildingName = common.getStore(obj, 'buildingName')

  // URLのgetパラメータから紹介会社コードを取得し、ストアに保持
  const urlParams = new URLSearchParams(window.location.search)
  const referralCompanyCode = urlParams.get('referralCompanyCode')
  common.setStore(obj, 'referralCompanyCode', referralCompanyCode)
}

//郵便番号変更時、selectbox初期化
function clear(obj) {
  obj.selected = ''
  obj.addressList = []
  obj.error.invalid_collectionArea = false
  obj.error.invalid_pickupZipcode = false
  obj.error.invalid_selected = false
  obj.error.nodata_pickupZipcode = false
}

//郵便番号から住所検索
function serchAddress(obj) {
  //初期化
  clear(obj)

  //郵便番号が入力済みの場合のAPI実行
  if ((obj.postcode.firstPickupZipcode.value) && (obj.postcode.lastPickupZipcode.value)) {

    let url = common.constant.GET_POSTALCODES_URL + obj.postcode.firstPickupZipcode.value + obj.postcode.lastPickupZipcode.value

    let func = function (response) {
      const data = response.data
      obj.addressList = []
      //取得した郵便番号マスタデータが0件の場合、エラーメッセージ
      if (data.postalCodes.length == 0) {
        obj.error.nodata_pickupZipcode = true
      }

      let ngCount = 0

      //取得した郵便番号マスタデータをループ
      data.postalCodes.forEach(postalCode => {

        // 住所選択リストに取得した郵便番号マスタデータをセット
        const postAddress = common.nvl(postalCode.TDFKN_KNJI, '') + common.nvl(postalCode.SKGNTYSNNM_KNJI, '') + common.nvl(postalCode.OAZTUSHONM_KNJI, '')
        postalCode['label'] = postAddress
        postalCode['code'] = postalCode.ID
        postalCode['isNgArea'] = isNgArea(postalCode)
        obj.addressList.push(postalCode)

        //NGエリアをカウント
        if (postalCode['isNgArea']) {
          ngCount++
        }
      });

      //該当する住所が1件の場合は、1件目を選択状態にする。
      if (data.postalCodes.length == 1) {
        obj.selected = data.postalCodes[0]
      }

      //選択肢が全て回収NGエリアの場合は、選択肢表示なし&メッセージ表示
      if (data.postalCodes.length > 0 && ngCount == data.postalCodes.length) {
        obj.addressList = []
        obj.error.invalid_collectionArea = true
      }

    }

    //郵便番号マスタ取得API実行
    common.executeAxiosGet(url, func, obj)

  } else {
    //郵便番号のいずれか未入力の場合、エラーメッセージ
    obj.error.invalid_pickupZipcode = true
  }

}
//住所チェック
function checkAddress(obj) {

  //選択された住所が回収不可エリアの場合
  obj.error.invalid_collectionArea = obj.selected.isNgArea
}

//回収NGかのチェック
function isNgArea(obj) {
  //選択された住所が回収不可エリアの場合
  return (obj.CYUKEIRYOKBN == common.constant.CYUKEIRYO_KBN)
    || (obj.LARGEDELIVERYKB == common.constant.LARGEDELIVERY_KB)
    || (obj.VALID_FLG == common.constant.VALID_FLG)
}

function submitAddressForm(obj) {
  //エラーフラグを初期化
  obj.setErrorFlg(false)

  //エラーメッセージを初期化
  obj.error.invalid_selected = false
  obj.error.invalid_address = false
  obj.error.required_address = false
  obj.error.invalid_buildingName = false

  //郵便番号必須チェック
  if ((obj.postcode.firstPickupZipcode.value === '') || (obj.postcode.lastPickupZipcode.value === '')) {
    obj.error.invalid_pickupZipcode = true
    obj.setErrorFlg(true)
  }

  //住所選択必須チェック
  if (obj.selected === '') {
    obj.error.invalid_selected = true
    obj.setErrorFlg(true)
  }

  // 住所チェック
  if (obj.addresses.address === '') {
    obj.error.required_address = true
    obj.setErrorFlg(true)
  } else if (!common.checkStr(obj.addresses.address)) {
    obj.error.invalid_address = true
    obj.setErrorFlg(true)
  }
  if (obj.addresses.buildingName && !common.checkStr(obj.addresses.buildingName)) {
    obj.error.invalid_buildingName = true
    obj.setErrorFlg(true)
  }

  //回収不可エリ選択時は時画面遷移させない
  if (obj.error.invalid_collectionArea) {
    obj.setErrorFlg(true)
  }

  //エラーフラグをストアにセット
  common.setStore(obj, 'errorFlg', obj.errorFlg())

  //ストアに入力した情報を保存
  if (obj.selected !== '') {
    obj.selected.YUBIN = obj.postcode.firstPickupZipcode.value + '-' + obj.postcode.lastPickupZipcode.value
  }

  common.setStore(obj, 'addressFormSelected', obj.selected)
  common.setStore(obj, 'addressList', obj.addressList)
  common.setStore(obj, 'address', obj.addresses.address)
  common.setStore(obj, 'buildingName', obj.addresses.buildingName)

  //storeの日時選択情報クリア
  common.setStore(obj, 'specificDate', '')
  common.setStore(obj, 'specificTime', '')

  // ストアから表示品目を取得
  let largeItems = common.getStore(obj, 'largeItems')
  // 画面遷移先をセット
  let path = common.constant.LARGE_ITEMS_PATH
  if (largeItems.length === 0 && common.countMediumView(obj) === 0) {
    path = common.constant.SMALL_ITEMS_PATH
  } else if (largeItems.length === 0) {
    path = common.constant.MEDIUM_ITEMS_PATH
  }
  common.setRoute(obj, path)
}

// 郵便番号の入力動作
function inputActions(obj, zipCodePart, e) {
  common.adjustMaxLength(zipCodePart, e)

  // フォーカスを移す
  let zip1 = document.getElementById('zip1')
  let zip2 = document.getElementById('zip2')
  if (e.target.id === 'zip1' &&
    e.target.value.length === e.target.maxLength
  ) {
    zip2.focus()
  } else if (e.target.id === 'zip2' &&
    e.target.value.length === e.target.maxLength &&
    zip1.value.length === zip1.maxLength
  ) {
    document.getElementById('address1').focus()
  }

  if (document.activeElement.id === 'address1' &&
    zip1.value.length === zip1.maxLength &&
    zip2.value.length === zip2.maxLength
  ) {
    serchAddress(obj)
  }
}

// 背景色
function getColor() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 ? this.siteCodeInfo[0].BACK_COLOR : ''
}

// 住所検索ボタン背景色
function getSearchAddressColor() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 ? this.siteCodeInfo[0].SEARCH_ADDRESS_BTN_COLOR : ''
}

// 画面遷移ボタン背景色
function getNextPageColor() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 ? this.siteCodeInfo[0].NEXT_PAGE_BTN_COLOR : ''
}

// 選択済み背景色
function getSelectedColor() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 ? this.siteCodeInfo[0].SELECTED_BTN_COLOR : ''
}

// 「回収品目の入力へ進む」ボタンの状態
function getDisableFlg() {
  return this.siteCodeInfo && this.siteCodeInfo.length > 0 && [1, 2].includes(this.siteCodeInfo[0].PRICING_METHOD) && this.hasItems ? false : true
}

// 表示品目セット
function setDisplayItems(obj, masterItems) {
  // 大型、中型の表示品目
  ['largeItems', 'mediumItems'].forEach(key => {
    let items = common.getStore(obj, key)
    if (items.length === 0) {
      items = common.getItems(obj.compItems[key], masterItems)
      common.setStore(obj, key, items)
    }
  });

  // 中型の「その他」、小型の表示品目
  ['addMediumItem', 'smallItems'].forEach(key => {
    let item = common.getStore(obj, key)
    if (Object.keys(item).length === 0) {
      let matchItem = masterItems.find(masterItem => masterItem.ITEM === obj.compItems[key].code)
      if (matchItem) {
        item = obj.compItems[key]
        // 小型、かつ個別画像指定の場合
        if (key === 'smallItems') {
            // 表示品目が「小型」のみの場合、初期値が1
          if (common.getStore(obj, 'largeItems').length + common.countMediumView(obj) === 0) {
            item.quantity = 1
            common.setStore(obj, 'smallTag', item.quantity)
            item.smallItemQuantity = 1
            common.setStore(obj, 'numOfSmallItemsTag', item.smallItemQuantity)
          }
          if (matchItem.IMAGE_FLG === '1') {
            item.image = common.isSmartPhone() ? matchItem.IMAGE_PATH_SP : matchItem.IMAGE_PATH_PC
          }
        }
      } else {
        item = {}
      }
      common.setStore(obj, key, item)
    }
  })
}

// 大型、中型、小型の表示品目数
function updateHasItems(obj) {
  let count = common.getStore(obj, 'largeItems').length + common.countMediumView(obj) + common.countSmallView(obj)
  if (count === 0) {
    obj.hasItems = false
    alert(obj.$msg.ERROR.MSG_9992)
  }
}

export default {
  common,
  inputRetention,
  clear,
  serchAddress,
  checkAddress,
  submitAddressForm,
  inputActions,
  getColor,
  getSearchAddressColor,
  getNextPageColor,
  getSelectedColor,
  getDisableFlg,
  setDisplayItems,
  updateHasItems,
}
